// extracted by mini-css-extract-plugin
export default {"container":"modal-title_container__QPLt1"};